import { CFG_CHIP_NAV_COMPACT, CFG_NAV_GRID_WIDE_LAST } from '../../lib/configuratorChip';
import { chipAccentStyle } from '../../lib/configuratorAccent';

export type SiblingGroupTile = {
  group_id: string;
  name: string;
  hint?: string;
  disabled?: boolean;
};

type Props = {
  sectionTitle: string;
  items: SiblingGroupTile[];
  activeGroupId: string | null;
  onNavigate: (groupId: string) => void;
  hapticSelection: () => void;
};

export function SiblingGroupTileNavigator({
  sectionTitle,
  items,
  activeGroupId,
  onNavigate,
  hapticSelection,
}: Props) {
  if (items.length < 2) return null;

  return (
    <div className="mt-3">
      <p
        className="text-[10px] font-bold uppercase tracking-widest mb-3 flex items-center gap-1.5"
        style={{ color: 'var(--text-3)' }}
      >
        <span style={{ color: 'var(--cyan)' }}>◈</span>
        {sectionTitle}
      </p>
      <div className={CFG_NAV_GRID_WIDE_LAST}>
        {items.map((item) => {
          const active = item.group_id === activeGroupId;
          const disabled = Boolean(item.disabled);
          return (
            <button
              key={item.group_id}
              type="button"
              disabled={disabled}
              title={disabled ? 'Нет вариантов в каталоге' : undefined}
              onClick={() => {
                if (active || disabled) return;
                hapticSelection();
                onNavigate(item.group_id);
              }}
              className={CFG_CHIP_NAV_COMPACT}
              style={chipAccentStyle('protocol', active)}
            >
              <span className="text-xs font-bold leading-tight">{item.name}</span>
              {item.hint ? (
                <span
                  className="text-[9px] font-normal leading-tight line-clamp-2 w-full"
                  style={{ color: active ? 'inherit' : 'var(--text-3)', opacity: active ? 0.85 : 1 }}
                >
                  {item.hint}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
